import { Edit } from "react-admin";
import { CategoryForm } from "./CategoryForm";

export const CategoryEdit = (props) => (
  <Edit title="Edição de Categoria" {...props}>
    <CategoryForm {...props} />
  </Edit>
);
